import { Card, Spinner } from "react-bootstrap";
import "./Login.css";
import logo from "../assets/img/LOGO CLAUDIO MESSINA_MONOGRAMMA PNG_MONOGRAMMA COLORE-05.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faSignIn } from "@fortawesome/free-solid-svg-icons";
import { Form, Input } from "antd";
import { useCallback, useState } from "react";
import classNames from "classnames";
import { useToasts } from "../contexts/toasts";
import Cookies from "js-cookie";
import { useAuth } from "../contexts/auth";
import { useNavigate } from "react-router-dom";
import { Users } from "../api/Users";

export default function Login() {
  const [loginForm] = Form.useForm();
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToasts();

  const handleLogin = useCallback(
    (values: any) => {
      const body = {
        username: values.username,
        password: values.password,
      };
      setLoading(true);
      Users.login(body).then(
        ({ data }) => {
          Cookies.set(
            window.__env.AUTH_TOKEN_NAME || "coaching-master-token",
            data.accessToken
          );
          if (data.refreshToken) {
            Cookies.set(
              window.__env.AUTH_REFRESH_TOKEN_NAME ||
                "coaching-master-refresh-token",
              data.refreshToken
            );
          }
          setToken(data.accessToken);
          setLoading(false);
          navigate("/dashboard");
        },
        () => {
          setLoading(false);
          showToast("user-error", "Email o Password errata", "", "danger");
        }
      );
    },
    [navigate, setToken, showToast]
  );

  return (
    <div className="login-container">
      <Card className="login-card">
        <Card.Body>
          <div className="login-hero">
            <span className="login-hero-logo">
              <img src={logo} alt="Coaching Master" />
            </span>
            <h1 className="login-hero-title">Coaching Master</h1>
            <span className="login-hero-subtitle">
              Inserisci le tue credenziali
            </span>
          </div>

          <Form
            className="login-form"
            form={loginForm}
            layout="vertical"
            onFinish={handleLogin}
            requiredMark={false}
          >
            <Form.Item
              name="username"
              label="Username"
              rules={[
                {
                  required: true,
                  message: "L'username è obbligatorio",
                },
              ]}
            >
              <Input size="large" placeholder="Username..." autoComplete="username" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "La password è obbligatoria",
                },
              ]}
            >
              <Input.Password
                placeholder="Password..."
                size="large"
                autoComplete="current-password"
                iconRender={(visible) => (
                  <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
                )}
              />
            </Form.Item>
            <button
              type="submit"
              disabled={loading}
              className={classNames("button-primary login-submit", {
                "button-disabled": loading,
              })}
            >
              {loading ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <FontAwesomeIcon icon={faSignIn} />
                  <span className="ms-2">Login</span>
                </>
              )}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
